module.exports = __webpack_public_path__ + "img/2025-08-16c_6.b72a92ae.jpg";